/** @format */

import {Box, Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import {Construction} from '@mui/icons-material';

import {LabelBox} from 'components/charts/multiline-chart/components/label-box';

import {WIDGETS_LIST} from '../../constants/widgets';
import {ChartIds} from '../../models/chartIds';
import {StubLayerRoot as Root, stubLayerClasses as classes} from './style';

interface Props {
  chartId: ChartIds;
  color: string;
}

const StubLayer = ({chartId, color}: Props) => {
  const widgetData = WIDGETS_LIST[chartId];

  return (
    <Root>
      <LabelBox chart={{chartId, color, label: widgetData.label, chartsData: []}} />
      <Box className={classes.gradient}>
        <Box className={classes.content}>
          <Typography className={classes.heading}>
            <Construction sx={{fontSize: 16}} />
            <Trans>Этот слой находится в разработке</Trans>
          </Typography>
          <Typography className={classes.text}>
            <Trans>
              Вы можете проголосовать за ускорение добавления его в цифровой слепок. Это поможет нам
              понять, что добавлять дальше.
            </Trans>
          </Typography>
          <Typography className={classes.arrowHint}>
            <Trans>Кнопка для голосования — на виджете сверху</Trans> ↑
          </Typography>
        </Box>
      </Box>
    </Root>
  );
};

export default StubLayer;
